export const localStorageEnum = {
  jobManagementFAQ: 'job_management_faq',
  uaBannerEnabled: 'ua_banner_enabled'
};
